import { render } from "./OpdConsultation.vue?vue&type=template&id=7d1cebbc&scoped=true"
import script from "./OpdConsultation.vue?vue&type=script&lang=js"
export * from "./OpdConsultation.vue?vue&type=script&lang=js"

import "./OpdConsultation.vue?vue&type=style&index=0&id=7d1cebbc&scoped=true&lang=scss"

import exportComponent from "C:\\Projects\\KneeLeadNew\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7d1cebbc"]])

export default __exports__